export const COLORS = {
  primary: "#318DFC",
  secondary: "#0263D8",
  orange: "#E1A66A",
  blue: "#1A90FF",
  blue1: "#87B0DE",
  brown1: "#D1C28B",
  white: "#fff",
  black: "#000000",
  green: "#9DDD7F",
  green1: "#9FD5A4",
  red: "#FC565E",
  yellow: "#F8D659",
  gray: "#6A6A6A",
  purple: "#CA9FD5",
  lightGray: "#dbdbdb",
  lightGray1: "#f5f6fa",
};

export const SIZES = {
  // global sizes
  base: 10,
  font: 14,
  radius: 12,
  padding: 24,

  // font sizes
  h1: 30,
  h2: 22,
  h3: 16,
  h4: 14,
  body1: 30,
  body2: 22,
  body3: 16,
  body4: 14,
  body5: 12,
  body6: 10,

  horizontalLine: {
    borderTopWidth: 1.5,
    borderTopColor: COLORS.primary,
  },
};

export const FONTS = {
  h1: {
    fontWeight: "bold",
    fontSize: SIZES.h1,
    lineHeight: 36,
  },

  h2: {
    fontWeight: "bold",
    fontSize: SIZES.h2,
    lineHeight: 30,
  },

  h3: {
    fontWeight: "bold",
    fontSize: SIZES.h3,
    lineHeight: 22,
  },

  h4: {
    fontWeight: "bold",
    fontSize: SIZES.h4,
    lineHeight: 22,
  },

  body1: {
    fontSize: SIZES.body1,
    lineHeight: 36,
  },

  body2: {
    fontSize: SIZES.body2,
    lineHeight: 30,
  },

  body3: {
    fontSize: SIZES.body3,
    lineHeight: 22,
  },

  body4: {
    color: "#808080",
    fontSize: SIZES.body4,
    lineHeight: 22,
  },

  body5: {
    color: "#808080",
    fontSize: SIZES.body5,
    lineHeight: 22,
  },
};

export const DateFormat = "MM-DD-YYYY";

const appTheme = {
  COLORS,
  SIZES,
  FONTS,
  DateFormat,
};

export default appTheme;
